// extracted by mini-css-extract-plugin
var _1 = "wq4rF";
export { _1 as "base" }
